import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "📋", key: "oneToTwo" },
  { emoji: "📦", key: "threeToFive" },
  { emoji: "🏆", key: "fivePlus" },
  { emoji: "🆓", key: "none" },
]

export default function SubscriptionCountPage() {
  return (
    <RadioCardListPage translationKey="subscriptionCount" options={OPTIONS} />
  )
}
